<div class="notloggedpage" *ngIf="displayDashboard">
  <div class="welcomeIMAGE">
    <img src="/assets/xpos-default-bg-image.png" alt="">
  </div>
  <div class="welcomeXPOS">
    <h2>Welcome to XPOS</h2>
    <p>Your payments partner</p>
  </div>
</div>
